<a [routerLink]="['/products/' + this.product().handle]">
  <div class="product-card">
    @if (isNew()) {
      <div class="d-flex justify-content-center align-items-center badge">
        <p class="mb-0 pb-0">New</p>
      </div>
    }
    <div class="d-flex flex-column align-items-center justify-content-center justify-content-md-evenly text-center h-100">
      <img [src]="product().variants[variantIndex].image.url" [alt]="product().image.altText">
      <div class="category my-2 mb-md-0">
        <p>{{product().category}}</p>
      </div>
      <div class="title">
        <h4>{{product().title}}</h4>
      </div>
      <div class="price my-2 my-md-0">
        <h4>${{product().variants[variantIndex].price.toFixed(2)}}</h4>
      </div>
      @if (product().variants[variantIndex].inventory > 0 && product().variants[variantIndex].amountInCart < product().variants[variantIndex].inventory) {
        <button
          class="primary w-75"
          (click)="addProductToCart(); $event.stopPropagation(); $event.preventDefault();">
          Add to Cart
        </button>
      } @else {
        <button class="primary w-75 text-black" disabled>
          Out of Stock
        </button>
      }
    </div>
  </div>
</a>
